import { useState, useRef } from "react";
import "./editorialForms.css";

export default function PortfolioForm({ data, onChange }) {
  const [techInput, setTechInput] = useState("");
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      const filePromises = files.map(file => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve({ file, preview: reader.result, name: file.name });
          };
          reader.readAsDataURL(file);
        });
      });
      
      Promise.all(filePromises).then(results => {
        onChange({ 
          ...data, 
          portfolioFiles: [...(data?.portfolioFiles || []), ...results]
        });
      });
    }
  };

  const categories = [
    "Web Development",
    "Mobile App",
    "UI/UX Design",
    "Branding",
    "Ilustracao",
    "Fotografia",
    "Video",
    "3D/Motion",
    "Game Design",
    "Marketing",
    "Data Science",
    "Outro",
  ];

  const handleAddTech = () => {
    if (techInput.trim()) {
      onChange({
        ...data,
        technologies: [...(data?.technologies || []), techInput.trim()],
      });
      setTechInput("");
    }
  };

  const handleRemoveTech = (index) => {
    onChange({
      ...data,
      technologies: (data?.technologies || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form portfolio_form">
      <div className="editorial_form_section">
        <label>
          Imagens/Vídeos do Projeto <span className="required">*</span>
        </label>
        <div className="file_upload_area" onClick={() => fileInputRef.current?.click()}>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*,video/*"
            multiple
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {data?.portfolioFiles?.length > 0 ? (
            <div className="file_selected">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
              </svg>
              <span>{data.portfolioFiles.length} arquivo(s) selecionado(s)</span>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, portfolioFiles: [] });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
              </svg>
              <p>Clique para fazer upload (múltiplos arquivos)</p>
              <span>Imagens e vídeos do projeto</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Nome do Projeto <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Redesign do App de Delivery"
          value={data?.projectName || ""}
          onChange={(e) => onChange({ ...data, projectName: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descricao</label>
        <textarea
          placeholder="Descreva o projeto, objetivos e resultados..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={2000}
          rows={4}
        />
      </div>

      <div className="editorial_form_section">
        <label>Categoria</label>
        <select
          value={data?.category || ""}
          onChange={(e) => onChange({ ...data, category: e.target.value })}
        >
          <option value="">Selecione</option>
          {categories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Cliente</label>
          <input
            type="text"
            placeholder="Nome do cliente"
            value={data?.client || ""}
            onChange={(e) => onChange({ ...data, client: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Seu Papel</label>
          <input
            type="text"
            placeholder="Ex: Lead Designer"
            value={data?.role || ""}
            onChange={(e) => onChange({ ...data, role: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Tecnologias / Ferramentas
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddTech}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: React, Figma, Node.js"
          value={techInput}
          onChange={(e) => setTechInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddTech()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.technologies || []).map((tech, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveTech(i)}
              style={{ cursor: "pointer" }}
            >
              {tech} x
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tamanho da Equipe</label>
          <input
            type="number"
            placeholder="Ex: 5"
            value={data?.teamSize || ""}
            onChange={(e) =>
              onChange({ ...data, teamSize: parseInt(e.target.value) || 0 })
            }
          />
        </div>

        <div className="editorial_form_section">
          <label>Duracao</label>
          <input
            type="text"
            placeholder="Ex: 3 meses"
            value={data?.duration || ""}
            onChange={(e) => onChange({ ...data, duration: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Link do Projeto</label>
        <input
          type="url"
          placeholder="https://..."
          value={data?.projectUrl || ""}
          onChange={(e) => onChange({ ...data, projectUrl: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Repositorio (se aplicavel)</label>
        <input
          type="url"
          placeholder="https://github.com/..."
          value={data?.repositoryUrl || ""}
          onChange={(e) => onChange({ ...data, repositoryUrl: e.target.value })}
        />
      </div>

      <div className="editorial_form_tip portfolio_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
        </svg>
        <span>
          Adicione projetos ao seu portfolio para mostrar suas habilidades.
          Inclua imagens e links para demonstrar o trabalho.
        </span>
      </div>
    </div>
  );
}
